function isFutureDate(date, now = new Date()) {
  return now < date;
}

export { isFutureDate };
